import React from 'react';
import PropTypes from 'prop-types';
import SimplePageTitle from '../../molecules/pageTitle/pageTitle';
import Tabs, { Tab } from '../../molecules/tabs/tabs';
import { childrenOf } from '../../../utils/proptypeTools';

const TabPage = (props) => {
  const {
    configFile,
  } = props;

  return (
    <div>
      <SimplePageTitle>{configFile.title}</SimplePageTitle>
      <Tabs value={configFile.initialTab}>
        {configFile}
      </Tabs>
    </div>
  );
};

TabPage.propTypes = {
  configFile: PropTypes.shape({
    noArea: PropTypes.bool,
    initialTab: PropTypes.string,
    title: PropTypes.string,
    getURL: PropTypes.string,
    createURL: PropTypes.string,
    updateURL: PropTypes.string,
    removeURL: PropTypes.string,
    idAttribute: PropTypes.string,
    websocketEventChanel: PropTypes.string,
    sessionParams: PropTypes.arrayOf(PropTypes.string),
    sessionWebsocketParams: PropTypes.arrayOf(PropTypes.string),
    loadFromFile: PropTypes.string,
    loadFromFileHelp: PropTypes.string,
    websocketItem: PropTypes.string,
    autoUpdate: PropTypes.bool,
    tabs: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.arrayOf(PropTypes.shape({}))]),
    tableConfig: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.arrayOf(PropTypes.shape({}))]),
    children: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.arrayOf(PropTypes.shape({}))]),

  }).isRequired,
  onCreate: PropTypes.func,
  onSave: PropTypes.func,
  onDelete: PropTypes.func,
};

TabPage.defaultProps = {
  onCreate: () => {},
  onSave: () => {},
  onDelete: () => {},
};

export default TabPage;
